// LookupHeader — Presentational header for the FlightLookup panel: the Plane
// icon + "Look Up Flight" title, and the conditional cancel (X) button that is
// only rendered when an `onCancel` callback is provided.
//
// Extracted verbatim from `FlightLookup.js` (the header block of the panel) as
// part of the behavior-preserving refactor (issue #240). Render-only, wrapped
// in React.memo. Markup, styles, icons (lucide-react), title text, and the
// `onCancel &&` conditional render guard are identical to the source.
//
// Props:
//   onCancel - optional callback; when provided, the cancel (X) button renders
//              and is wired to it, exactly as the source did
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { Plane, X } from 'lucide-react';

export const LookupHeader = React.memo(function LookupHeader({ onCancel }) {
  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: '16px'
    }}>
      <h3 style={{
        fontSize: '18px',
        fontWeight: '600',
        color: '#1f2937',
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        gap: '8px'
      }}>
        <Plane size={20} style={{ color: '#0ea5e9' }} />
        Look Up Flight
      </h3>
      {onCancel && (
        <button
          onClick={onCancel}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '4px',
            borderRadius: '4px',
            color: '#6b7280',
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <X size={18} />
        </button>
      )}
    </div>
  );
});

export default LookupHeader;
